// extracted by mini-css-extract-plugin
export default {"wrap":"SurveyCustomAnswer_wrap__+nxfk","empty":"SurveyCustomAnswer_empty__11Glx","answer":"SurveyCustomAnswer_answer__77K+I"};